import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BulkDocumentSuccess from './bulk-document-success';

const BulkDocumentSuccessPage = () => {
  const reduxValidationData = useSelector((state) => state.bulkPolicy.validationData);
  const navigate = useNavigate();

  return (
    <div style={{ padding: 12 }}>
      <BulkDocumentSuccess
        validationData={reduxValidationData}
        handleBackClick={() => {
          // Navigate back to the bulk documents initial page
          navigate('/documents/bulk');
        }}
      />
    </div>
  );
};

export default BulkDocumentSuccessPage;
